import axiosInstance from '../axios/axiosInstance';
import { ExamTemplate } from '../model/response';
import { ExamTemplateRequest } from '../model/request';

export const findExamTemplatesById = async (id: string) => {
  const { data } = await axiosInstance.get<ExamTemplateRequest>(`exam-templates/${id}`);
  return data;
};

export const findAllExamTemplates = async () => {
  const { data } = await axiosInstance.get<ExamTemplate[]>('exam-templates', { params: { fromCMS: true } });
  return data;
};
